<template>
    <el-dialog
        :title="title"
        class="zt-config-dialog"
        width="542px"
        :model-value="visible"
        :before-close="close"
        :close-on-click-modal="false">
        <div v-if="deleteFail" class="fail-info">{{failText}}</div>
        <!-- <div v-show="confirmInfo" class="confirm-info">{{confirmInfo}}</div> -->
        <div class="confirm-wrapper">
            <slot>{{message}}</slot>
        </div>
        <template #footer>
            <div class="dialog-footer">
                <el-button type="primary" @click="submitForm" :disabled="loading" :loading="loading">{{okText}}</el-button>
                <el-button style="margin-left: 7px" @click="close">{{cancelText}}</el-button>
            </div>
        </template>
    </el-dialog>
</template>

<script>
import {noopFn} from '@/util/util';
import {Vue, Prop} from 'vue-property-decorator';

export default class ZtConfirmDialog extends Vue {
    
    @Prop({type: Boolean, default: false}) visible;
    @Prop({type: String, default: ''}) title;
    @Prop({type: String, default: '确认'}) okText;
    @Prop({type: String, default: '取消'}) cancelText;
    @Prop({type: Function, default: noopFn}) onCancel;
    @Prop({type: Function, default: noopFn}) onOk;

    // @Prop({type: String, default: ''}) confirmInfo;
    @Prop({type: String, default: ''}) message;
    
    deleteFail = false;
    loading = false;
    failText = '';
    state = 'waiting';

    close() {
        this.onCancel();
    }

    submitForm() {
        this.deleteFail = false;
        this.loading = true;
        this.onOk(e => {
            this.loading = false;
            if (typeof e === 'undefined') {
                this.close();
            } else {
                const message = e.message;
                this.failText = message;
                this.deleteFail = true;
            }
        });
    }

}

</script>


<style lang="scss">
.zt-config-dialog {
    position: relative;
    .fail-info {
        position: absolute;
        width: 100%;
        top: 40px;
        left: 0;
        text-align: center;
        color: #FF5B70;
    }
    .confirm-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 108px;
    }
    .el-dialog__footer {
        position: relative;
        margin-top: 10px;
    }
}
</style>
